var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{
      'vue-loading-button': true,
      'loading': _vm.loading,
    },attrs:{"disabled":_vm.loading,"type":"button"}},[_vm._t("default",[_vm._v("Submit")]),_vm._m(0)],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"spinner"},[_c('span'),_c('span'),_c('span'),_c('span')])}]

export { render, staticRenderFns }